import {
  ADDORGANIZATION,
  DELETEORGANIZATION,
  EDITORGANIZATION,
  LISTOFORGANIZATION,
  VIEWOFRGANIZATION,
  ONBOARDING_STATUS,
} from "./apiRoutes";
import { authData } from "./Service";

export const listOfOrganizationApi = async (data) => {
  const response = await authData.post(LISTOFORGANIZATION, data);
  return response?.data;
};

export const addOrganizationApi = async (data) => {
  const response = await authData.post(ADDORGANIZATION, data);
  return response?.data;
};

export const editOrganizationApi = async (id, data) => {
  const response = await authData.put(`${EDITORGANIZATION}${id}`, data);
  return response?.data;
};
export const deleteOrganizationApi = async (id) => {
  const response = await authData.delete(`${DELETEORGANIZATION}${id}`);
  return response?.data;
};
export const viewOrganizationApi = async (id) => {
  const response = await authData.get(`${VIEWOFRGANIZATION}${id}`);
  return response?.data;
};

export const getOnboardingStatusApi = async (id) => {
  const response = await authData.get(`${ONBOARDING_STATUS}${id}/onboarding-status`);
  return response?.data;
};
